export const THANKYOUPAGE_URL_PARAMS = "THANKYOUPAGE/THANKYOUPAGE_URL_PARAMS";
export const THANKYOUPAGE_INFO ="THANKYOUPAGE/THANKYOUPAGE_INFO";
export const UPDATE_BOOKING_STATUS ="THANKYOUPAGE/UPDATE_BOOKING_STATUS";
export const SET_THANKYOU_ERROR = "THANKYOUPAGE/SET_THANKYOU_ERROR";
export const SET_FEEDBACK_STATUS ="THANKYOU_PAGE/SET_FEEDBACK_STATUS";